import Vue from 'vue'
import axios from './vue-axios/axios'

export function getContractTemplates() {
  return Vue.axios.get('/v1/contract_templates')
}

export function contractTemplatesListFromEntity(entity_id) {
  return Vue.axios.get(`/v1/entities/${entity_id}/contract_templates`);
}

export function getContractPdf(params) {
  return Vue.axios({
    method: 'GET',
    url: '/v1/contract_templates/pdf',
    params: params,
    responseType: 'blob'
  });
}

export function createContract(params) {
  return axios.post('/v1/contracts', params);
}

export function getContract(contractId) {
  return axios.get(`/v1/contracts/${contractId}`);
}

export function deleteContract(contractId) {
  return axios.delete(`/v1/contracts/${contractId}`);
}

export function signContract(contractId) {
  return axios.put(`/v1/contracts/${contractId}/sign`);
}

export function addContractStep(contractId, params) {
  return Vue.axios.post(`/v1/contracts/${contractId}/comment`, params);
}

export function getAuthorizations(templateId, params) {
  return axios.get(`/v1/contract_templates/${templateId}/authorizations`, {
    params: params
  });
}

export function validateOfferForContractTemplate(templateId, params) {
  return Vue.axios.get(`/v1/contract_templates/${templateId}/validate`, {
    params: params
  });
}

export function updateContractFields(offerId, params) {
  return Vue.axios.put(`/v1/offers/${offerId}/contract_fields`, params);
}



// WEBPACK FOOTER //
// ./src/backend/contracts.js